<div class="row pg-style">
  <div class="col-sm-12 pg-style">
    <div class="row search-banner">
      <div class="col-sm-12 search-banner-col">
        <h2 class="h3 search-banner-title">Summary Of Changes</h2>
      </div>
    </div>
    <div class="row search-nav">
      <div class="col-sm-12 search-nav-col">
        <ul class="list-inline search-nav-list">
          <li><button type="button" (click)="toggle('session')" [class.search-nav-active]="selectedHeader() === 'session'">Session</button></li>
          <li><button type="button" (click)="toggle('previousTransaction')" [class.search-nav-active]="selectedHeader() === 'previousTransaction'">Previous Transactions</button></li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="row transactions-search-comp">
  <div class="col-sm-12 card">
    @if (isFetching() && !showDetails()) {
    <ng-container>
      <rs-loader></rs-loader>
    </ng-container>
    }
    @if (!showDetails() && selectedHeader() === 'previousTransaction') {
    <ng-container>
      <client-search [selectedAdminPlan]="selectedAdminPlan()" [features]="['basic', 'advanced']"
                     (resetSelected)="clientSearchReset($event)"></client-search>
      @if (!(selectedSubClients().length && !backToResults())) {
      <ng-container>
        <client-search-results [hideContentOnNoResults]="true" (subClientSelected)="subClientSelected($event)">
        </client-search-results>
      </ng-container>
      }
      @if (selectedSubClients().length && !backToResults()) {
      <ng-container>
        <div class="selected-group-info">
          <button type="button" class="group-content" (click)="backToSearchResults()">
            <b>Group: </b><span>{{selectedSubClients()[0].planAcronym}} {{selectedSubClients()[0].client.specifiedId}} {{selectedSubClients()[0].client.name}} </span>
            <b>Subgroup: </b><span>{{selectedSubClients()[0].specifiedId}} {{selectedSubClients()[0].name}}</span>
          </button>
        </div>
        <form [formGroup]="dateForm" (ngSubmit)="onSearchSubmitted()">
          <div class="row date-form">
            <div class="col-sm-2">
              <rs-input formControlName="startDate" type="date" strictDateTyping placeholder="MM/DD/YYYY" label="From Date" validation="eager" min="1900-01-01"></rs-input>
            </div>
            <div class="col-sm-2">
              <rs-input formControlName="endDate" type="date" strictDateTyping placeholder="MM/DD/YYYY" label="To Date" validation="eager" min="1900-01-01"></rs-input>
            </div>
            <div class="col-sm-2 date-submit-button">
              <button [disabled]="isFetching() || !dateForm.valid" rs-raised-button color="primary">Submit</button>
            </div>
          </div>
        </form>
      </ng-container>
      }
    </ng-container>
    }
    @if ((selectedHeader() === 'session' || isSearched()) && !showDetails()) {
    <ng-container>
      <app-user-transactions [transactions]="transactionsSignal()" (selectedTransaction)="selectedTransaction($event)"></app-user-transactions>
      <rs-paginator showFirstLastButtons [length]="transactionsRecordsSignal().totalRecords || 0"
                     (page)="pageChanged($event)" [pageSize]="defaultPageSize"></rs-paginator>
    </ng-container>
    }
    @if (showDetails()) {
    <ng-container><app-summary-details (backToTransactions)="backToTransactions($event)"></app-summary-details></ng-container>
    }
  </div>
</div>

